import { Component } from 'react';
import { connect } from 'react-redux';
import {goBack, push, replace} from 'react-router-redux';
import lodash from 'lodash';

import {
    addApplicationHeaderTitle
} from 'common/actions/applicationHeader';

import {
    loadSdfaInboxItem,
    clearSdfaItem
} from 'forms/actions/sdfa';
import { documentTypePermissionsSelector } from 'common/permissions/selectors';
import LoadingComponent from 'common/permissions/components/LoadingComponent';
import {
    SubFormRouter,
    SubFormRoute
} from 'forms/containers/SubFormRouter/SubFormRouter';
import WorkflowDocumentViewer from 'workflow/containers/WorkflowDocumentViewer';
import SdfaInboxItem from 'forms/components/Sdfa/InboxItem';

export class SdfaTaskSummary extends Component {

    componentDidMount() {
        const { loadSdfaInboxItem, taskId } = this.props;
        loadSdfaInboxItem(taskId);
    }

    componentWillUnmount() {
        this.props.clearSdfaItem();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pageTitle === null && nextProps.inboxItem) {
            this.props.addApplicationHeaderTitle(nextProps.inboxItem.name);
        }
    }

    viewDocument() {
        const { push, location } = this.props;
        const updatedLocation = lodash.cloneDeep(location);
        updatedLocation.query.subformroute = 'viewDocument';
        push(updatedLocation);
    }

    render() {
        const { inboxItem, document, viewDocumentPermission } = this.props;

        if (lodash.isNull(inboxItem)) {
            return <LoadingComponent />;
        }

        return (
            <SubFormRouter data-cy="Read">
                <SubFormRoute>
                    <SdfaInboxItem
                        taskId={this.props.taskId}
                        inboxItem={inboxItem}
                        document={document}
                        viewDocumentPermission = {viewDocumentPermission}
                        viewDocument={this.viewDocument.bind(this)} />
                </SubFormRoute>
                <SubFormRoute query="viewDocument">
                    <WorkflowDocumentViewer taskId={this.props.taskId} />
                </SubFormRoute>
            </SubFormRouter>
        );
    }
}

export default connect((state, props) => {
    const inboxItem = lodash.get(state, 'form.inboxItem', null);
    const document = lodash.get(state, 'form.inboxItem.document', null);
    const documentTypeId = lodash.get(state, 'form.inboxItem.document.documentType.id', null);
    const viewDocumentPermission = documentTypePermissionsSelector(state, documentTypeId);
    const taskId = lodash.get(props, 'params.id', null);
    const location = props.location;
    const pageTitle = lodash.get(state, 'app.pageTitle', null);

    return {
        inboxItem,
        document,
        taskId,
        pageTitle,
        location,
        viewDocumentPermission,
    };
}, {
    loadSdfaInboxItem,
    clearSdfaItem,
    addApplicationHeaderTitle,
    replace,
    push,
    goBack
}
)(SdfaTaskSummary);
